export const START_OF_DAY = {
  defaultHour: 0,
  defaultMinute: 0,
};

export const END_OF_DAY = {
  defaultHour: 23,
  defaultMinute: 59,
};
